
enum LoadState {
    NoLoad = 1,
    Loading = 2,
    LoadSuccess = 3,
    LoadFail = 4
}

export default LoadState;